import { FormControl, FormLabel, OutlinedInput } from "@mui/material"
import React from "react"

type ComponentProps = {
  label: string
  value?: string
  required: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function TextField(props: ComponentProps) {
  const { label, value, onChange, required } = props
  return (
    <FormControl
      required={required}
      sx={{
        width: "100%",
        padding: "10px",
        paddingBottom: "0px",
        paddingTop: "0px",
      }}
    >
      <FormLabel
        sx={{
          color: "#6F7482",
          fontSize: "16px",
        }}
      >
        {label}
      </FormLabel>
      <OutlinedInput
        sx={{
          borderRadius: "10px",
          width: "100%",
          height: "48px",
          backgroundColor: "white",
        }}
        value={value}
        onChange={onChange}
      />
    </FormControl>
  )
}

export default TextField
